export default __webpack_public_path__ + "static/media/adyen.24a285cc.svg";